import { Link } from '@tanstack/react-router';
import { T, useGT } from 'gt-react';
import { toast } from 'sonner';
import type { RemittanceDetail } from '@erp/rpc';
import { useConfirmLineItemMatch } from '@/api/rpc/hooks/accounts-receivable/useArRemittances';
import { Button } from '@/components/ui/button';

export function RemittanceInvoiceCandidates({
  lineItem,
  editable,
}: {
  lineItem: Pick<RemittanceDetail['lineItems'][number], 'id' | 'candidates'>;
  editable: boolean;
}) {
  const confirm = useConfirmLineItemMatch();
  const gt = useGT();
  return (
    <div className="space-y-2 text-sm">
      <p className="text-amber-800" role="status">
        <T>
          Multiple matches or conflicting interpretations. Review before linking
          an invoice.
        </T>
      </p>
      {lineItem.candidates.map((candidate) => (
        <div key={candidate.id} className="flex items-center gap-2">
          <Link
            to="/accounts-receivable/invoices/$arInvoiceId"
            params={{ arInvoiceId: candidate.id }}
            className="text-blue-600 hover:underline"
          >
            {candidate.invoiceNumber ?? candidate.id}
          </Link>
          <span>{candidate.customerName}</span>
          {editable && (
            <Button
              size="sm"
              variant="outline"
              disabled={confirm.isPending}
              onClick={() =>
                confirm.mutate(
                  { lineItemId: lineItem.id, invoiceId: candidate.id },
                  {
                    onError: () =>
                      toast.error(
                        gt('Could not confirm invoice. Refresh and try again.'),
                      ),
                  },
                )
              }
            >
              <T>Select and confirm</T>
            </Button>
          )}
        </div>
      ))}
    </div>
  );
}
